import styled from "styled-components"
import { Link } from "react-router-dom"

export const Container = styled.div`
    background-color: var(--medGrey);
    display: flex;
`

export const Wrapper = styled.div`
    flex: 1;
`

export const Main = styled.div`
    margin-top: 10px;
    flex: 4;
    color: var(--darkGrey);
    padding: 20px;
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Title = styled.h1`
`

export const WideBox = styled.div`
    margin-bottom: 20px;
    padding: 20px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    border-radius: 10px;
    color: var(--lightGrey);
    font-size: var(--fontS);
`

export const UserColumn = styled.div`
    display: flex;
    align-items: center;
`

export const UserImage = styled.img`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
`

export const UserInfo = styled.span``

export const UserDetails = styled.div`
    display: flex;
    flex-direction: column;
`

export const ProductDetail = styled.div`
    display: flex;  
`

export const ProductImage = styled.img`
    width: 200px;
`

export const ProductDetails = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: var(--lightGrey);
    font-size: var(--fontS);    
`

export const ProductInfo = styled.span``

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    cursor: pointer;
`